import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  const languages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ar', name: 'عربي', flag: '🇴🇲' },
  ];

  return (
    <div className="relative group">
      <button
        className="flex items-center space-x-1 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
        data-testid="language-selector"
      >
        <Globe size={18} className="text-maquette-blue" />
        <span className="text-sm font-medium">{languages.find(l => l.code === language)?.flag}</span>
      </button>
      
      <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            data-testid={`lang-${lang.code}`}
            className={`w-full flex items-center space-x-3 px-4 py-3 hover:bg-maquette-blue/10 hover:text-maquette-blue transition-colors first:rounded-t-lg last:rounded-b-lg ${
              language === lang.code ? 'bg-maquette-blue/10 text-maquette-blue font-semibold' : 'text-maquette-text'
            }`}
          >
            <span className="text-lg">{lang.flag}</span>
            <span className="text-sm font-medium">{lang.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;